import React, {createRef} from "react";
import {connect} from "react-redux";
import {withRouter} from "react-router";
import {withTranslation} from "react-i18next";
import {toast} from "react-toastify";
import classNames from "classnames";
import "./index.scss";

import {DELETE} from "../../../store/reducers/common-actions";

import {isRTL} from "../../../services/userModel";
import RoleManager from "../../../services/roleManage";
import {filterWithWrappedMobileColumns} from "../../../services/filter";

import {CONFIRM_DIALOG_TYPE, CONTROL_TYPE, ROLES_MANAGER_TYPE} from "../../../utils/enums";
import {createAction} from "../../../utils/sagaHelper";
import {defaultPromiseResolve} from "../../../utils/objects-util";
import {getHistoryLocationParams} from "../../../utils/routesHelper";

import ConfirmDialog from "../../containers/ConfirmDialogContainer";
import Svg from "../Waiter/Svg";
import IconButton from "../IconButton";
import EditItemControl from "../EditItemControl";
import SectionItemEditControl from "../SectionItemEditControl";
import LinkControl from "../LinkControl";
import IconWithQuantity from "../IconWithQuantity";

class SectionItem extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      courierConfirmDialogType: null,
      showConfirmDialog: false,
      isWithPassword: false,
      isOpenWrappedMobileList: false,
    };

    this.ref = createRef();
    this.handleOnConfirmDialog = this.handleOnConfirmDialog.bind(this);
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleOnResize);
  }

  componentWillUnmount() {
    this.isUnmount = true;
    window.removeEventListener("resize", this.handleOnResize);
  }

  getIsDraggable = () => {
    const { sectionModel } = this.props;
    return sectionModel && sectionModel.isDraggable;
  };

  getUrl = (column, item) => {
    const { location, sectionModels, sectionModel } = this.props;
    const { id } = getHistoryLocationParams(location.search);
    const parentUrl = sectionModels[sectionModel.parentUrl]
      ? sectionModels[sectionModel.parentUrl].id
      : "";
    const backParentId = parentUrl || id;
    return column.link
      ? backParentId
        ? `${column.link}?parentId=${backParentId}&id=${item[sectionModel.key]}`
        : `${column.link}?id=${item[sectionModel.key]}`
      : "";
  };

  getItem = (column, item, items) => {
    const {
      history,
      location,
      sectionModels,
      sectionModel,
      onPropChange,
      onLayout
    } = this.props;
    const isReadonly = RoleManager.instance.isReadonlyPage(sectionModel.typeModel);
    const { id } = getHistoryLocationParams(location.search);
    const parentUrl = sectionModels[sectionModel.parentUrl]
      ? sectionModels[sectionModel.parentUrl].id
      : "";
    const backParentId = parentUrl || id;
    let url = column.link
      ? backParentId
        ? `${column.link}?parentId=${backParentId}&id=${item[sectionModel.key]}`
        : `${column.link}?id=${item[sectionModel.key]}`
      : "";
    url = column.isSubId
      ? `${column.link}&subId=${item[sectionModel.key]}`
      : url;

    const handleOnClickIconWithQuantity = (column, item) => {
      if (column.isLayout) {
        onLayout(column.url(item), item);
      } else {
        history.push(column.url(item));
      }
    };

    if (column.component) {
      return column.component(item, onLayout, onPropChange, items, sectionModel.filterOptions);
    } else if (column.isEditable) {
      return (
        <SectionItemEditControl
          id={item[sectionModel.key]}
          column={{...column, isReadonly: column.isReadonly || isReadonly}}
          item={item}
          onPropChange={onPropChange}
        />
      );
    } else if (
      column.type === CONTROL_TYPE.link &&
      (!column.isShow || column.isShow(item))
    ) {
      return (
        <>
          {(!column.isVisible || (column.isVisible && column.isVisible(item))) && <>
            <div className={"warnIcon"}>
              {column.hasWarningIcon &&
                  column.hasWarningIcon(item) && (
                      <IconButton
                          isIcon={true}
                          iconName={"warn"}
                          onClick={defaultPromiseResolve}
                      />
                  )}
            </div>
            <IconButton
                isIcon={true}
                isFullWH={column.iconFullWH}
                iconName={column.iconName}
                tooltipText={column.tooltipText}
                onClick={() => {
                  return new Promise(resolve => {
                    resolve();
                    history.push(url, {some: "state"});
                  });
                }}
            /></>}

        </>
      );
    } else if (column.type === CONTROL_TYPE.linkSvg) {
      return (
          <Svg
              useSvg={column.iconName}
              useClass="iconSvg"
              tooltipText={column.tooltipText}
              handleOnClick={() => history.push(url)}
          />
      );
    } else if (column.type === CONTROL_TYPE.iconWithQuantity) {
      return (
          <IconWithQuantity
              onClick={() => handleOnClickIconWithQuantity(column, item)}
              item={item}
              column={column}
          />
      );
    } else if (column.type === CONTROL_TYPE.linkAction) {
      return (
          <IconButton
              isIcon={true}
              iconName={column.iconName}
          tooltipText={column.tooltipText}
          onClick={() => this.handleOnLinkAction(column, item)}
        />
      );
    } else if (column.type === CONTROL_TYPE.linkControl) {
      return (
        <LinkControl
          column={{ title: item[column.accessor], isLayout: column.isLayout, isReadonly: column.isReadonly || isReadonly }}
          value={column.url(item)}
          onLayout={onLayout}
          onClick={() => onLayout(column.url(item), item)}
        />
      );
    } else {
      return (
        <div className={classNames("contentText")}>{item[column.accessor]}</div>
      );
    }
  };

  getColumns = () => {
    const { item, sectionModel } = this.props;

    return sectionModel.columns.filter(column => {
      const isShowLink = [CONTROL_TYPE.link, CONTROL_TYPE.linkSvg].includes(
        column.type
      )
        ? RoleManager.instance.isAuthorized(
            ROLES_MANAGER_TYPE.menu,
            column.link
          )
        : true;
      const isShowLinkAction = [CONTROL_TYPE.linkAction].includes(column.type)
        ? RoleManager.instance.isAuthorized(
            CONTROL_TYPE.linkAction,
            column.link
          )
        : true;
      const isLinkIconComponent =
        column.type === CONTROL_TYPE.linkIconComponent
          ? RoleManager.instance.isAuthorized(
              CONTROL_TYPE.linkIconComponent,
              column.link
            )
          : true;

      return (
        isShowLink &&
        isShowLinkAction &&
        isLinkIconComponent &&
        (!column.isShow || column.isShow(item))
      );
    });

  };

  handleOnLinkAction = (column, item) => {
    const { itemAction } = this.props;
    return new Promise((resolve, reject) => {
      resolve();

      if (
        column.isConfirm &&
        column.isConfirm(item) &&
        (!column.isShow || column.isShow(item))
      ) {
        this.handleOnShowConfirmDialog(
          CONFIRM_DIALOG_TYPE.default,
          false,
          column
        );
      } else {
        this.column = column;
        itemAction(column.link, item);
      }
    });
  };

  handleOnResize = () => {
    this.forceUpdate();
  };

  handleOnShowConfirmDialog = (type, isWithPassword = false, column) => {
    this.setState({
      courierConfirmDialogType: type,
      showConfirmDialog: true,
      isWithPassword: isWithPassword,
      column: column
    });
  };

  handleOnCancelConfirmDialog = () => {
    this.setState({
      courierConfirmDialogType: null,
      showConfirmDialog: false,
      isWithPassword: false
    });
  };

  handleOnConfirmDialog = token => {
    const { courierConfirmDialogType, column } = this.state;
    const { item, sectionModel, itemAction, onRefreshPagination } = this.props;
    this.idProcessDelete = item[sectionModel.key];

    return new Promise((resolve, reject) => {
      switch (courierConfirmDialogType) {
        case CONFIRM_DIALOG_TYPE.deleteItem:
          itemAction(sectionModel.actionName + DELETE, {
            id: item[sectionModel.key],
            item
          }).then(
            () => {
              if (!this.isUnmount) {
                resolve();
                this.handleOnCancelConfirmDialog();
                this.idProcessDelete = null;
              }
            }, error => {
              toast.error(error || "Error");
              reject(error || "Error");
            }
          );
          break;
        case CONFIRM_DIALOG_TYPE.default:
          itemAction(column.link, item).then(
            () => {
              if (!this.isUnmount) {
                resolve();
                this.handleOnCancelConfirmDialog();
                this.idProcessDelete = null;
              }
            },
            error => {
              toast.error(error || "Error");
              reject(error || "Error");
            }
          );
          break;
        default:
          resolve();
          this.handleOnCancelConfirmDialog();
          break;
      }

    }).then(() => onRefreshPagination());
  };

  handleOnDragStart = e => {
    const { item, onDragStart, saveDragModeLoader } = this.props;
    if (this.getIsDraggable() && onDragStart && !saveDragModeLoader) {
      e.target.style.opacity = "0.4";
      onDragStart(e, item);
    }
  };

  handleOnDragEnd = e => {
    if (this.getIsDraggable()) {
      e.target.style.opacity = "1";
    }
  };

  handleOnDrop = e => {
    const { item, onDrop, saveDragModeLoader } = this.props;
    if (this.getIsDraggable() && onDrop && !saveDragModeLoader) {
      onDrop(e, item);
    }
  };

  handleOnDragEnter = e => {
    const { index, onDragEnter, saveDragModeLoader } = this.props;
    if (this.getIsDraggable() && onDragEnter && !saveDragModeLoader) {
      onDragEnter(e, index);
    }
  };

  handleOnLayout = link => {
    const { item, onLayout } = this.props;
    onLayout && onLayout(link, item);
  };

  getWrappedMobileColumns = columns => {
    return columns.filter(
      column =>
        column.wrapOnMobileWidth &&
        window.innerWidth <= column.wrapOnMobileWidth
    );
  };

  handleToggleWrappedMobileItems = () => {
    this.setState({ isOpenWrappedMobileList: !this.state.isOpenWrappedMobileList })
  }

  getColumnWidth = (column) => {
    if(window.innerWidth > 620) {
      if(column.width) {
        return `${column.width}`;
      }
      return 'auto';
    }
    if(column.type === CONTROL_TYPE.link) {
      return column.width;
    }
    if(column.fixedWidth) {
      return column.width;
    }
    return 'auto';
  }


  render() {
    const { showConfirmDialog, isWithPassword } = this.state;
    const { t, item, dragIndex, index, sectionModel, saveDragModeLoader, items } = this.props;
    const columns = this.getColumns();
    const wrappedMobileColumns = this.getWrappedMobileColumns(columns);
    const isShowDeleteButton =
      sectionModel.showDeleteButton &&
      !sectionModel.isCustomEditIcon &&
      !columns.some(column => column.isHideDeleteButton && column.isHideDeleteButton(item)) &&
      RoleManager.instance.isAuthorized(ROLES_MANAGER_TYPE[CONTROL_TYPE.linkIconComponent], sectionModel.typeModel + "DeleteButton");

    const isCanEdit = RoleManager.instance.isAuthorized(
      ROLES_MANAGER_TYPE[CONTROL_TYPE.linkIconComponent],
      sectionModel.typeModel + "AddButton"
    );


    return (
      <table
        className={classNames("contentItems", {
          dropable: dragIndex === index,
          rtl: isRTL()
        })}
      >
        <tbody>
          <tr
            ref={this.ref}
            draggable={!saveDragModeLoader && this.getIsDraggable()}
            onDragEnter={this.handleOnDragEnter}
            onDragStart={this.handleOnDragStart}
            onDragEnd={this.handleOnDragEnd}
            onDrop={this.handleOnDrop}
          >
            {this.getIsDraggable() && (
              <td style={{ width: "40px" }}>
                <IconButton
                  isIcon={true}
                  iconName={"move"}
                  onClick={defaultPromiseResolve}
                />
              </td>
            )}
            {filterWithWrappedMobileColumns(columns).map(
              (column, index) => (
                <td
                  key={`item-${column.title}-${index}`}
                  className={classNames("contentItem", {
                    confirmItem: column.skipOverflow,
                    hide:
                      (column.hideWidth &&
                        window.innerWidth <= column.hideWidth) ||
                      (column.showWidth &&
                        window.innerWidth >= column.showWidth),
                    centered: column.centered
                  })}
                  style={{ width:  this.getColumnWidth(column), whiteSpace: column.whiteSpace ? column.whiteSpace : 'inherit' }}
                >
                  {this.getItem(column, item, items)}
                </td>
              )
            )}
            {wrappedMobileColumns.length ? (
              <td
                className={classNames("contentItem", "confirmItem", "wrappedMobileItem")}
                style={{ width: "40px" }}
              >
                <IconButton
                  isIcon={true}
                  iconName={"settings"}
                  onClick={this.handleToggleWrappedMobileItems}
                />
                <div className={classNames("contentWrappedMobileContainer", this.state.isOpenWrappedMobileList && "contentWrappedMobileContainerOpened")}>
                  {wrappedMobileColumns.map((column, index) => {
                    return <div key={column.title + '-' + column.accessor + '-' + index} className="contentWrappedMobileItem">{this.getItem(column, item)}</div>;
                  })}
                </div>
              </td>
            ) : null}
            {isShowDeleteButton ||
            showConfirmDialog ||
            sectionModel.isCustomEditIcon
                ? <td
              className={classNames("contentItem", "confirmItem")}
              style={{ width: sectionModel.deleteWidth || (sectionModel.hideHeaderItemControls ? '40px' : "90px"), textAlign: 'center' }}
            >
              {(isShowDeleteButton && !item.isShowDeleteButton) && (
                <IconButton
                  isIcon={true}
                  iconName={"deleteItem"}
                  tooltipText={t("settings.users.USER_TOOLS_DELETE_TOOLTIP")}
                  onClick={() => {
                    return new Promise(resolve => {
                      resolve();
                      this.handleOnShowConfirmDialog(
                        CONFIRM_DIALOG_TYPE.deleteItem
                      );
                    });
                  }}
                />
              )}
                  {!isShowDeleteButton && item.isShowDeleteButton && (
                      <IconButton
                          isIcon={true}
                          iconName={"deleteItem"}
                          tooltipText={t("settings.users.USER_TOOLS_DELETE_TOOLTIP")}
                          onClick={() => {
                            return new Promise(resolve => {
                              resolve();
                              this.handleOnShowConfirmDialog(
                                  CONFIRM_DIALOG_TYPE.deleteItem
                              );
                            });
                          }}
                      />
                  )}
              {showConfirmDialog &&
                !sectionModel.isCustomEditIcon && (
                  <ConfirmDialog
                    isWithPassword={isWithPassword}
                    useWrapperClass={classNames("confirmDialog")}
                    useBtnConfirmClass={classNames(
                      "btn",
                      "confirm",
                      "btnConfirmDialog"
                    )}
                    handleOnConfirm={this.handleOnConfirmDialog}
                    handleOnCancel={this.handleOnCancelConfirmDialog}
                    labelText={""}
                  />
                )}
              {sectionModel.isCustomEditIcon &&
                isCanEdit && (
                  <EditItemControl
                    item={item}
                    value={sectionModel.editControlsConfig}
                    onLayoutOpen={this.handleOnLayout}
                  />
                )}
            </td> : null}
          </tr>
        </tbody>
      </table>
    );
  }
}

const mapStateToProps = state => ({
  sectionModels: state.sectionModel.sectionModels,
  items:
      state.sectionModel.sectionModels[state.sectionModel.currentModelType]
          .model &&
      state.sectionModel.sectionModels[
          state.sectionModel.currentModelType
          ].model.mappingLambda(
          state,
          state.sectionModel.sectionModels[state.sectionModel.currentModelType].id
      ),
});

const mapDispatchToProps = dispatch => {
  return {
    itemAction: (action, data) => dispatch(createAction(action, data))
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(SectionItem))
);
